module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/college-mobile-be105677c972f49ddcf7c690834fe8f8.jpg";